import { SwapOutlined } from '@ant-design/icons'
import { Button, Modal, Select } from 'antd'
import React, { useState } from 'react'
import axiosInstance from '../../../variables/api/axiosInstance';
import { toast } from 'react-toastify';

const ChangeProfilUtilisateur = ({ utilisateur, buttonStyle, profils, navigate, param, requireActive, isSecurityLocked, securityLockMessage }) => {
    const [loading, setLoading] = useState(false);
    const [profilModalOpen, setProfilModalOpen] = useState(false);
    const [selectedProfil, setSelectedProfil] = useState(utilisateur?.profil?.codeId);
    const isDisabled = !utilisateur?.active || isSecurityLocked;
    const disabledButtonStyle = {
        backgroundColor: '#E5E7EB',
        borderColor: '#E5E7EB',
        color: '#9CA3AF',
        boxShadow: 'none',
        cursor: 'not-allowed',
        opacity: 1,
    };

    const onSubmitChangeProfil = () => {
        if (requireActive("modifier le profil")) return;
        if (isSecurityLocked) {
            toast(securityLockMessage || "Action non autorisée.");
            return;
        }

        setLoading(true);
        const profil = profils.find((p) => p.codeId === selectedProfil);
        utilisateur.profil = profil;
        axiosInstance
            .put(
                `/api/utilisateur/update-profil`,
                JSON.stringify(utilisateur))
            .then((res) => {
                // console.log(res.data);
                setLoading(false);
                setProfilModalOpen(false);
                navigate(`/details-utilisateur/${res.data.codeId}`, { replace: true });
                toast("Profil modifié avec succès");
            })
            .catch((err) => {
                console.log(err);
                toast("Erreur lors de la modification du profil");
                setLoading(false);
            });
    };

    return (
        <div
            style={{
                backgroundColor: 'white',
                borderRadius: '12px',
                padding: '24px',
                border: '2px solid #E6F0FF',
                transition: 'all 0.3s ease'
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                <div style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '12px',
                    backgroundColor: '#D1FAE5',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <SwapOutlined style={{ fontSize: '24px', color: '#10B981' }} />
                </div>
                <div>
                    <h4 style={{ fontSize: '16px', fontWeight: '600', color: '#242166', margin: 0 }}>
                        Profil
                    </h4>
                    <p style={{ fontSize: '12px', color: '#6B7280', margin: 0 }}>
                        Changer le rôle
                    </p>
                </div>
            </div>
            <p style={{ fontSize: '14px', color: '#6B7280', marginBottom: '16px' }}>
                Modifiez le profil et les permissions associées
            </p>
            {securityLockMessage && (
                <p style={{ fontSize: '12px', color: '#b45309', marginBottom: '12px' }}>
                    {securityLockMessage}
                </p>
            )}
            <Button
                icon={<SwapOutlined />}
                block
                onClick={() => {
                    if (isSecurityLocked) {
                        toast(securityLockMessage || "Action non autorisée.");
                        return;
                    }
                    setProfilModalOpen(true);
                }}
                disabled={isDisabled}
                style={
                    isDisabled
                        ? { ...buttonStyle, ...disabledButtonStyle }
                        : { ...buttonStyle, backgroundColor: '#10B981', borderColor: '#10B981', color: 'white' }
                }
            >
                Changer le profil
            </Button>

            <Modal
                open={profilModalOpen && !isSecurityLocked}
                onCancel={() => setProfilModalOpen(false)}
                zIndex={10000}
                centered
                onOk={onSubmitChangeProfil}
                loading={loading}
            >
                <form
                    id="addNewAddressForm"
                    className="row g-12"
                    onSubmit={onSubmitChangeProfil}
                >
                    <div className="col-12 col-md-12">
                        <div className="text-center">
                            {/* <h4 className="address-title mb-2">Octroyer une dérogation</h4> */}
                            <p className="address-subtitle">
                                Modifier le profil de votre utilisateur{" "}
                                <b>
                                    {utilisateur?.personne?.nom} {utilisateur?.personne?.prenom}
                                </b>
                            </p>
                        </div>
                        <div class="row">
                            <div class="col-md-12 select2-primary">
                                <label class="form-label" for="formtabs-language">
                                    Veuillez sélectionner le nouveau profil
                                </label>
                                <Select
                                    style={{
                                        width: "100%",
                                    }}
                                    placeholder="Veuillez sélectionner les habilitations spéciales sur le module"
                                    onChange={(value) => setSelectedProfil(value)}
                                    options={profils?.map((prof, id) => ({
                                        label: prof.nom,
                                        value: prof.codeId,
                                        key: id,
                                    }))}
                                    defaultValue={utilisateur?.profil?.codeId}
                                    value={selectedProfil}
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </Modal>
        </div>
    )
}

export default ChangeProfilUtilisateur
